import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function useRedirectOnBack() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleBackNavigation = () => {
      // Controlla se il percorso inizia con "/payment-result" o è esattamente "/checkout"
      if (
        location.pathname.startsWith("/payment-result") ||
        location.pathname === "/checkout"
      ) {
        // Reindirizza alla homepage
        navigate("/", { replace: true });
      }
    };

    // Aggiungi l'evento "beforeunload" per intercettare quando l'utente cerca di uscire dalla pagina
    window.addEventListener("beforeunload", handleBackNavigation);

    // Controlla l'evento di navigazione indietro nel caso in cui venga usato il pulsante "back"
    return () => {
      window.removeEventListener("beforeunload", handleBackNavigation);
    };
  }, [location, navigate]);
}

export default useRedirectOnBack;
